import React from 'react';

const Policy = () => {
    return (

        <div className="policy-content-container">
            <h1>Delta Group’s Messaging Privacy Policy </h1>
            <h2 className='bold-policy'>Effective Date: 10/17/2025 </h2>
            <p className='policy-content-body'>
                RE/MAX Delta Group, INC. and Delta Property Management Group LLC. (“we,” “us,” “our”) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how RE/MAX Delta Group, INC. and Delta Property Management Group LLC. collects and uses information about you when you opt-in to receive SMS messages from us.  
                <p className='bold-policy'>Information We Collect</p>
                When you opt-in to receive SMS messages, we collect: 
                <ul>
                    <li>Your phone number</li>
                    <li>Your consent to send SMS messages </li>
                    <li>Your basic contact information  </li>
                    <li>Your messaging history with the company</li>
                </ul>
                <p className='bold-policy'>How We Collect Your Information </p>
                We may collect your information directly from you, such as when you complete a form or contact us or automatically, such as when you interact with our website. 
                <p>How We Use Your Information</p>
                We use your information to:
                <ul>
                    <li>Send you the SMS messages you’ve opted in to receive</li>
                    <li>Provide updates, promotions, or other relevant content based on your preferences</li>
                    <li>Choices and Controls</li>
                    <li>To operate our business</li>
                </ul>
                <p>If you have any questions or concerns regarding your privacy or the handling of your personal data, please contact us directly at the following email address: info@yourdomain.com.</p>
                <p>Your data will not be transferred to external organizations under any circumstances.</p>
                <p>We implement strict policies and technical measures to prevent unauthorized access, disclosure, or sharing of your data. These include:</p>
                <ul>
                <li>Access controls to restrict data handling to authorized personnel only</li>
                <li>Regular monitoring and auditing of data access and usage</li>
                <li>Encryption of data during storage and transmission</li>
                <li>Continuous review and improvement of our data protection practices</li>
                </ul>
                You can opt out of receiving SMS messages at any time by replying STOP to any message we send you. You can review our Terms at www.deltapmg.com/toc for additional information about the opt-out process. 
                <p className='bold-policy'>To Whom We Disclose Your Information</p>
                We may disclose your information to our affiliated companies; to third party service providers, business advisors, or consultants who provide services to us; in connection with a merger, acquisition, reorganization, restructuring, financing transaction or sale of assets; as required by law or administrative order; and to assert claims or rights or to defend against claims.
                We do not share your personal information, phone number, or SMS consent opt-in data with third parties or affiliates for marketing or promotional purposes. 
                <p className='bold-policy'>Protection of Information</p>
                We take steps to protect your information against unauthorized use or disclosure.
                <p className='bold-policy'>Updates</p>
                We may periodically update this privacy policy. If we make material changes that have a substantive and adverse impact on your privacy, we will provide notice on this website prior to the change becoming effective. We encourage you to periodically review this page for the latest information about our privacy practices. 
                <p className='bold-policy'>How to Contact Us</p>
                You can reach us by texting the word HELP for support to 1-717-671-7676. You can reach us by calling our support at 1-717-671-7676. 
            </p>
        </div>

    );

};

export default Policy;